import React from "react";
import { Button, Box, Grid } from "@tiny/components";
import SubscribersList from "../../components/SubscribersList";
import useBreakpoints from "@tiny/components/src/hooks/useBreakpoints";
import MainHeader from "@tiny/components/src/MainHeader";
import TinyImportDialog, {
  TinyImporter,
} from "../../components/TinyImportDialog";
import AudienceDetailsStatistics from "../AudienceDetailsStatistics";
import { useAudienceSourceAll } from "./AudienceSourceAll.hooks";
import useTinyImporter from "../../hooks/useTinyImporter";

function AudienceSourceAll() {
  const { mdUp, lgUp } = useBreakpoints();
  const [value, setValue] = React.useState();
  const { segmentDetails, gotoAudienceDetails, refetchSegmentStatistics } =
    useAudienceSourceAll();
  const {
    tinyImporterOpen,
    tinyImportDialogOpen,
    closeTinyImportDialog,
    openTinyImportDialog,
    closeTinyImporter,
    openTinyImporter,
  } = useTinyImporter();

  return (
    <>
      <Box overflow={{ xs: "hidden", lg: "initial" }}>
        <MainHeader
          title="All customers"
          backUrl="/main/audience?tab=sources"
          action={
            <Button
              variant="contained"
              fullWidth
              onClick={openTinyImportDialog}
            >
              Add audience
            </Button>
          }
        />
        <Grid container spacing={lgUp ? 5 : mdUp ? 4 : 2}>
          <Grid item xs={12}>
            <AudienceDetailsStatistics
              segmentDetails={segmentDetails}
              all={false}
            />
          </Grid>
          <Grid item xs={12}>
            <SubscribersList
              pageName="audienceSource"
              bgcolor="white"
              borderRadius={mdUp ? "8px" : "0px"}
              showChip
              onAfterDelete={refetchSegmentStatistics}
              enableEdit
            />
          </Grid>
        </Grid>
      </Box>
      <TinyImportDialog
        open={tinyImportDialogOpen}
        onClose={closeTinyImportDialog}
        onSuccess={(name) => {
          setValue(name);
          openTinyImporter();
        }}
      />
      <TinyImporter
        open={tinyImporterOpen}
        onClose={closeTinyImporter}
        value={value}
        onSuccess={gotoAudienceDetails}
      />
    </>
  );
}

export default AudienceSourceAll;
